/* Five Origins — Academia FOCA · diploma și distribuirea
   Se încarcă după fo-academy.js și se agață de window.FOA. */
(function () {
  'use strict';
  var A = window.FOA; if (!A) return;

  function state() { return A.getState(); }
  function DATAX() { return A.data(); }
  function $(s) { return A.q(s); }
  function esc(v) { return A.esc(v); }
  function rankOf(b) { return A.rankOf(b); }
  function stampsOwned() { return A.stampsOwned(); }

  /* ---------- pictograme de distribuire ---------- */
  var ICON = {
    share: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3v13M12 3 8 7M12 3l4 4"/><path d="M5 12v7a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-7"/></svg>',
    fb: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M14.5 8.5V6.9c0-.7.2-1.1 1.2-1.1h1.5V3.1c-.3 0-1.2-.1-2.2-.1-2.2 0-3.7 1.3-3.7 3.8v1.7H9v3h2.3V21h3.2v-9.5h2.4l.4-3h-2.8Z" fill="currentColor" stroke="none"/></svg>',
    ig: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="3" width="18" height="18" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.2" cy="6.8" r="1.1" fill="currentColor" stroke="none"/></svg>',
    wa: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2a10 10 0 0 0-8.6 15l-1.3 4.7 4.8-1.3A10 10 0 1 0 12 2Zm5.1 14c-.2.6-1.2 1.2-1.7 1.2-.5.1-1 .1-1.6-.1-.4-.1-.9-.3-1.5-.6-2.6-1.1-4.3-3.8-4.4-4-.1-.2-1-1.4-1-2.6s.6-1.8.9-2.1c.2-.2.5-.3.7-.3h.5c.2 0 .4 0 .6.5l.8 1.9c.1.2 0 .4-.1.5l-.3.4-.3.3c-.1.1-.2.3-.1.5.1.2.6 1.1 1.4 1.8 1 .9 1.8 1.1 2 1.2.2.1.4.1.5-.1l.7-.9c.2-.2.3-.1.5-.1l1.9.9c.2.1.4.2.4.3.1.2.1.7-.1 1.4Z" fill="currentColor" stroke="none"/></svg>',
    li: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6.9 8.7H3.7V21h3.2V8.7ZM5.3 3A1.9 1.9 0 1 0 5.3 6.8 1.9 1.9 0 0 0 5.3 3ZM20.3 13.9c0-3.1-1.7-4.6-3.9-4.6-1.8 0-2.6 1-3 1.7V8.7H10c0 .9 0 12.3 0 12.3h3.3v-6.9c0-.3 0-.6.1-.8.3-.6.8-1.3 1.8-1.3 1.3 0 1.8 1 1.8 2.4V21h3.3v-7.1Z" fill="currentColor" stroke="none"/></svg>',
    copy: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="9" y="9" width="11" height="11" rx="2"/><path d="M5 15V6a1 1 0 0 1 1-1h9"/></svg>'
  };

  /* ---------- diplomă ---------- */
  var LOGO = null, MEDAL = null, IMG_TRIED = false;
  function loadImg(url, cb) {
    if (!url) { cb(null); return; }
    var im = new Image();
    im.crossOrigin = 'anonymous';
    im.onload = function () { cb(im); };
    im.onerror = function () { cb(null); };
    im.src = url;
  }
  function ensureLogo(cb) {
    if (IMG_TRIED) { cb(); return; }
    var b = DATAX().brand || {}, left = 2;
    var done = function () { if (--left === 0) { IMG_TRIED = true; cb(); } };
    loadImg(b.logo, function (im) { LOGO = im; done(); });
    loadImg(b.medal, function (im) { MEDAL = im; done(); });
  }

  function serial() {
    var base = 0, str = (state().name || '') + '|' + state().beans;
    for (var i = 0; i < str.length; i++) base = (base * 31 + str.charCodeAt(i)) >>> 0;
    return 'FO-' + new Date().getFullYear() + '-' + ('0000' + (base % 10000)).slice(-4);
  }

  function roundRect(x, a, b, w, h, r) {
    x.beginPath();
    x.moveTo(a + r, b); x.lineTo(a + w - r, b); x.quadraticCurveTo(a + w, b, a + w, b + r);
    x.lineTo(a + w, b + h - r); x.quadraticCurveTo(a + w, b + h, a + w - r, b + h);
    x.lineTo(a + r, b + h); x.quadraticCurveTo(a, b + h, a, b + h - r);
    x.lineTo(a, b + r); x.quadraticCurveTo(a, b, a + r, b); x.closePath();
  }

  function corner(x, cx, cy, sx, sy) {
    x.save(); x.translate(cx, cy); x.scale(sx, sy);
    x.strokeStyle = '#a8792f'; x.lineWidth = 2;
    x.beginPath(); x.arc(56, 56, 40, Math.PI, Math.PI * 1.5); x.stroke();
    x.lineWidth = 1;
    x.beginPath(); x.arc(56, 56, 48, Math.PI, Math.PI * 1.5); x.stroke();
    x.beginPath(); x.arc(20, 20, 4, 0, Math.PI * 2); x.fillStyle = '#97392a'; x.fill();
    x.restore();
  }

  function drawDiploma() {
    var cv = $('[data-foa-canvas]'); if (!cv) return;
    ensureLogo(function () { paintDiploma(cv); });
  }

  function paintDiploma(cv) {
    var x = cv.getContext('2d'); if (!x) return;
    var W = cv.width, H = cv.height;
    var r = rankOf(state().beans);
    var name = (state().name || '').trim();
    var owned = stampsOwned();

    var PAPER = '#f7f2e7', INK = '#241c14', RED = '#97392a', GOLD = '#a8792f', MUT = '#6f6455';

    x.fillStyle = PAPER; x.fillRect(0, 0, W, H);

    // textură discretă
    x.save(); x.globalAlpha = .045; x.fillStyle = '#6f6455';
    for (var i = 0; i < 2600; i++) x.fillRect(Math.random() * W, Math.random() * H, 1.4, 1.4);
    x.restore();

    // chenar dublu
    x.strokeStyle = INK; x.lineWidth = 7; roundRect(x, 28, 28, W - 56, H - 56, 10); x.stroke();
    x.strokeStyle = GOLD; x.lineWidth = 1.5; roundRect(x, 46, 46, W - 92, H - 92, 6); x.stroke();
    corner(x, 52, 52, 1, 1); corner(x, W - 52, 52, -1, 1);
    corner(x, 52, H - 52, 1, -1); corner(x, W - 52, H - 52, -1, -1);

    // logo real, prin multiply (fundalul alb dispare pe hârtie)
    var topY = 104;
    if (LOGO && LOGO.width) {
      var lw = 300, lh = lw * (LOGO.height / LOGO.width);
      x.save(); x.globalCompositeOperation = 'multiply';
      x.drawImage(LOGO, (W - lw) / 2, topY, lw, lh);
      x.restore();
      topY += lh + 18;
    } else {
      x.textAlign = 'center'; x.fillStyle = INK; x.font = '700 40px Georgia, serif';
      x.fillText('FIVE ORIGINS COFFEE', W / 2, topY + 34);
      topY += 66;
    }

    x.textAlign = 'center';
    x.fillStyle = GOLD; x.font = '700 20px Georgia, serif';
    x.fillText('A C A D E M I A   F O C A', W / 2, topY + 6);

    x.strokeStyle = GOLD; x.lineWidth = 1;
    x.beginPath(); x.moveTo(W / 2 - 150, topY + 26); x.lineTo(W / 2 - 30, topY + 26); x.stroke();
    x.beginPath(); x.moveTo(W / 2 + 30, topY + 26); x.lineTo(W / 2 + 150, topY + 26); x.stroke();
    x.fillStyle = RED; x.beginPath(); x.arc(W / 2, topY + 26, 4, 0, Math.PI * 2); x.fill();

    x.fillStyle = INK; x.font = '700 62px Georgia, serif';
    x.fillText('Diplomă de ' + r.name, W / 2, topY + 110);

    x.fillStyle = MUT; x.font = 'italic 400 24px Georgia, serif';
    x.fillText('se acordă lui', W / 2, topY + 168);

    x.fillStyle = RED; x.font = 'italic 700 56px Georgia, serif';
    x.fillText(name || '— numele tău —', W / 2, topY + 244);
    x.strokeStyle = '#d8cdb6'; x.lineWidth = 2;
    x.beginPath(); x.moveTo(W / 2 - 320, topY + 274); x.lineTo(W / 2 + 320, topY + 274); x.stroke();

    x.fillStyle = '#43382c'; x.font = '400 24px Georgia, serif';
    x.fillText('pentru ' + state().beans + ' boabe adunate și ' + owned.length +
      (owned.length === 1 ? ' ștampilă' : ' ștampile') + ' în pașaportul de cafea', W / 2, topY + 322);

    // ștampilele, desenate
    var all = DATAX().tracks.map(function (t) { return t.stamp; });
    var sw = 96, gap = 26, totalW = all.length * sw + (all.length - 1) * gap;
    var sx = (W - totalW) / 2, sy = topY + 360;
    all.forEach(function (label, k) {
      var on = owned.indexOf(label) > -1;
      var cx = sx + k * (sw + gap) + sw / 2, cy = sy + sw / 2;
      x.save(); x.translate(cx, cy); x.rotate(on ? (k % 2 ? .07 : -.06) : 0);
      x.strokeStyle = on ? RED : '#cdc2ab';
      x.lineWidth = on ? 3 : 1.5;
      if (!on) x.setLineDash([5, 5]);
      x.beginPath(); x.arc(0, 0, sw / 2, 0, Math.PI * 2); x.stroke();
      x.setLineDash([]);
      x.fillStyle = on ? RED : '#a89c85';
      x.font = '700 15px Georgia, serif'; x.textAlign = 'center';
      x.fillText(label, 0, 5);
      x.restore();
    });

    // medalionul real, decupat circular ca să dispară fundalul pătrat
    var mcx = W - 196, mcy = H - 196, mr = 84;
    if (MEDAL && MEDAL.width) {
      x.save();
      x.shadowColor = 'rgba(36,28,20,.28)'; x.shadowBlur = 22; x.shadowOffsetY = 7;
      x.beginPath(); x.arc(mcx, mcy, mr, 0, Math.PI * 2); x.closePath();
      x.fillStyle = PAPER; x.fill();
      x.restore();
      x.save();
      x.beginPath(); x.arc(mcx, mcy, mr, 0, Math.PI * 2); x.clip();
      // medalionul e pătrat; îl mărim puțin ca marginea deschisă a fișierului să cadă în afara cercului
      var d = mr * 2.22;
      x.drawImage(MEDAL, mcx - d / 2, mcy - d / 2, d, d);
      x.restore();
      x.strokeStyle = GOLD; x.lineWidth = 2;
      x.beginPath(); x.arc(mcx, mcy, mr + 1, 0, Math.PI * 2); x.stroke();
      x.strokeStyle = RED; x.lineWidth = 1;
      x.beginPath(); x.arc(mcx, mcy, mr + 9, 0, Math.PI * 2); x.stroke();
    } else {
      x.save(); x.translate(mcx, mcy); x.rotate(-.1);
      x.strokeStyle = RED; x.lineWidth = 4;
      x.beginPath(); x.arc(0, 0, 76, 0, Math.PI * 2); x.stroke();
      x.fillStyle = RED; x.textAlign = 'center';
      x.font = '700 19px Georgia, serif'; x.fillText('FOCA', 0, -6);
      x.font = '400 12px Georgia, serif'; x.fillText('ACADEMIA', 0, 16);
      x.restore();
    }

    var dt = new Date();
    var luni = ['ianuarie','februarie','martie','aprilie','mai','iunie','iulie','august','septembrie','octombrie','noiembrie','decembrie'];
    x.textAlign = 'left'; x.fillStyle = MUT; x.font = '400 17px Georgia, serif';
    x.fillText(dt.getDate() + ' ' + luni[dt.getMonth()] + ' ' + dt.getFullYear(), 92, H - 96);
    x.font = '400 14px Georgia, serif'; x.fillStyle = '#8a7f6e';
    x.fillText(serial(), 92, H - 70);
    x.textAlign = 'center'; x.font = '400 17px Georgia, serif'; x.fillStyle = MUT;
    x.fillText((DATAX().brand && DATAX().brand.site) || '5origins.com', W / 2, H - 70);

    var a = $('[data-foa-dl]');
    if (a) { try { a.href = cv.toDataURL('image/png'); } catch (e) { a.removeAttribute('href'); } }
  }

  /* ---------- share ---------- */
  function shareText() {
    var r = rankOf(state().beans);
    return 'Am luat diploma de ' + r.name + ' la Academia FOCA, cu ' + state().beans +
           ' boabe. Încearcă și tu, durează trei minute.';
  }
  function shareUrl() {
    return (DATAX().brand && DATAX().brand.shareUrl) || window.location.href.split('?')[0];
  }
  function canvasBlob(cb) {
    var cv = $('[data-foa-canvas]'); if (!cv || !cv.toBlob) { cb(null); return; }
    try { cv.toBlob(function (b) { cb(b); }, 'image/png'); } catch (e) { cb(null); }
  }
  function nativeShare() {
    canvasBlob(function (blob) {
      var payload = { title: 'Academia FOCA', text: shareText(), url: shareUrl() };
      if (blob && window.File && navigator.canShare) {
        var f = new File([blob], 'diploma-five-origins.png', { type: 'image/png' });
        if (navigator.canShare({ files: [f] })) payload.files = [f];
      }
      if (navigator.share) {
        navigator.share(payload).catch(function () { /* anulat de utilizator */ });
      } else {
        copyText(shareText() + ' ' + shareUrl());
      }
    });
  }
  function copyText(t) {
    var done = function () { $('[data-foa-live]').textContent = 'Text copiat.'; flashShare('Copiat'); };
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(t).then(done, function () { });
    } else {
      var ta = document.createElement('textarea');
      ta.value = t; document.body.appendChild(ta); ta.select();
      try { document.execCommand('copy'); done(); } catch (e) { }
      document.body.removeChild(ta);
    }
  }
  function flashShare(msg) {
    var el = $('[data-foa-sharemsg]'); if (!el) return;
    el.textContent = msg;
    setTimeout(function () { if (el) el.textContent = ''; }, 2200);
  }
  /* Instagram nu acceptă imagini prin link — pe telefon folosim share-ul nativ,
     pe calculator descărcăm imaginea și spunem ce urmează. */
  function instagramShare() {
    if (navigator.share) { nativeShare(); return; }
    var a = $('[data-foa-dl]');
    if (a && a.getAttribute('href')) { a.click(); }
    flashShare('Imaginea s-a descărcat. Încarc-o ca postare sau story pe Instagram.');
  }

  function openShare(net) {
    var u = encodeURIComponent(shareUrl()), t = encodeURIComponent(shareText());
    var map = {
      fb: 'https://www.facebook.com/sharer/sharer.php?u=' + u,

      wa: 'https://api.whatsapp.com/send?text=' + t + '%20' + u,
      li: 'https://www.linkedin.com/sharing/share-offsite/?url=' + u
    };
    if (map[net]) window.open(map[net], '_blank', 'noopener,width=640,height=640');
  }


  window.FOA_DIPLOMA = {
    icons: ICON,
    draw: drawDiploma,
    share: function (net) {
      if (net === 'native') nativeShare();
      else if (net === 'copy') copyText(shareText() + ' ' + shareUrl());
      else if (net === 'ig') instagramShare();
      else openShare(net);
    }
  };
})();
